import values from 'lodash/values';

export const previewTypes = {
  FIRST_20_SEC: 'first-20-sec',
  TRAILER: 'trailer',
  // type 'url' is temporarily commented, will return in vod phase 2
  // URL: 'url',
  NONE: 'none',
};

export default values(previewTypes);



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/constants/preview-types.js